import { render, staticRenderFns } from "./ProfileItem.vue?vue&type=template&id=196fc0ce&scoped=true"
import script from "./ProfileItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileItem.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196fc0ce",
  null
  
)

export default component.exports